export type MobileOS = 'android' | 'ios' | null;

export const getMobileOS = (userAgent: string): MobileOS => {
    // https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system
    if (/android/i.test(userAgent)) {
        return 'android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return 'ios';
    }

    return null;
};
